// Spinner de carregamento com o logótipo "G" (Gresart), usado em toda a aplicação
// em substituição do ícone genérico "Sparkle"/círculo a girar.
const LOGO_URL = "https://customer-assets-rejwkqb3.emergentagent.net/job_ea05fd14-44c9-4674-8c56-754eef17102d/artifacts/0rd2p5ji_image.png";

export const LoadingSpinner = ({ size = 32, className = "" }) => (
  <img
    src={LOGO_URL}
    alt="A carregar..."
    style={{ width: size, height: size, animationDirection: "reverse" }}
    className={`animate-spin inline-block ${className}`}
    data-testid="loading-spinner"
  />
);
